/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { PersonGbRolleMitRecht } from './personGbRolleMitRecht';
import { PersonGbMasterId } from './personGbMasterId';
import { PersonGbVersionDetailEntryMeta } from './personGbVersionDetailEntryMeta';


export interface PersonGbMasterDetailEntryMeta { 
    versions?: Array<PersonGbVersionDetailEntryMeta>;
    mVersions?: FieldMetaData;
    hasAuskunftssperre?: PersonGbMasterDetailEntryMeta.HasAuskunftssperreEnum;
    mHasAuskunftssperre?: FieldMetaData;
    rolleMitRecht?: PersonGbRolleMitRecht;
    mRolleMitRecht?: FieldMetaData;
    id: PersonGbMasterId;
    mId?: FieldMetaData;
    personGbArt?: PersonGbMasterDetailEntryMeta.PersonGbArtEnum;
    mPersonGbArt?: FieldMetaData;
    mitglieder?: Array<PersonGbMasterDetailEntryMeta>;
    mMitglieder?: FieldMetaData;
    isAuslaendischeRechtsform?: boolean;
    mIsAuslaendischeRechtsform?: FieldMetaData;
    egbpid?: string;
    mEgbpid?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    personstammMasterId: PersonStammMasterId;
    mPersonstammMasterId?: FieldMetaData;
}
export namespace PersonGbMasterDetailEntryMeta {
    export type HasAuskunftssperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const HasAuskunftssperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as HasAuskunftssperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as HasAuskunftssperreEnum,
        KEINE: 'KEINE' as HasAuskunftssperreEnum
    };
    export type PersonGbArtEnum = 'ALLE_PERSON' | 'NATUERLICHE_PERSON' | 'JURISTISCHE_PERSON' | 'GEMEINSCHAFT' | 'OEFFENTLICH_RECHTLICHE_PERSON';
    export const PersonGbArtEnum = {
        ALLE_PERSON: 'ALLE_PERSON' as PersonGbArtEnum,
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as PersonGbArtEnum,
        JURISTISCHE_PERSON: 'JURISTISCHE_PERSON' as PersonGbArtEnum,
        GEMEINSCHAFT: 'GEMEINSCHAFT' as PersonGbArtEnum,
        OEFFENTLICH_RECHTLICHE_PERSON: 'OEFFENTLICH_RECHTLICHE_PERSON' as PersonGbArtEnum
    };
}


